<template>
  <div class="py-3">
    <div class="border border-1 rounded-3 p-3 mb-3">
      <!-- 🔵 TÍTULO SUPERIOR -->
      <div class="row mb-3 border-bottom pb-2 mx-1">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <h4 class="text-success mb-0 fw-bold">
            <i class="bi bi-person-plus-fill me-2"></i>NUEVO POSTULANTE
          </h4>
        </div>
      </div>

      <div class="position-relative py-1 px-5">
        <div v-if="alerta" class="alert alert-info" role="alert">
          se añadio el nuevo usuario!!
        </div>
      </div>

      <form @submit.prevent="registrar">
        <!-- 🔵 SECCIÓN FOTO Y TALLAS -->
        <div class="row py-2 mx-1">
          <!-- COLUMNA IZQUIERDA: FOTO Y TALLAS (APILADAS VERTICALMENTE) -->
          <div class="col-12 col-md-3 border-end pe-md-4 mb-4 mb-md-0">
            <div class="text-center mb-4">
              <label
                for="imageUpload"
                class="image-upload-circle d-flex justify-content-center align-items-center mx-auto position-relative mb-2 shadow-sm"
              >
                <div
                  v-if="loadingImagen"
                  class="spinner-border text-success"
                  role="status"
                ></div>
                <template v-else>
                  <span v-if="!previewUrl" class="upload-text text-muted small"
                    >Subir foto</span
                  >
                  <img
                    v-else
                    :src="previewUrl"
                    alt="Foto Postulante"
                    class="img-preview"
                  />
                </template>
                <div class="overlay-camera">
                  <i class="bi bi-camera-fill"></i>
                </div>
              </label>
              <input
                type="file"
                id="imageUpload"
                accept="image/*"
                style="display: none"
                @change="handleImageUpload"
              />
              <p class="reducirTamaño text-secondary fw-bold text-center">
                FOTO TIPO CARNET <br />(FONDO BLANCO)
              </p>
            </div>

            <div class="mb-3 bg-light p-2 rounded shadow-sm">
              <label class="tamaño d-flex align-items-center gap-2 mb-1">
                <i class="bi bi-person-fill text-warning"></i> TALLA
                POLO:</label
              >
              <select class="form-select tamaños" v-model="form.posPolo">
                <option disabled value="">-- SELECCIONAR --</option>
                <option
                  v-for="polo in polos"
                  :key="polo.id"
                  :value="polo.parCorrelativo"
                >
                  {{ polo.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="mb-3 bg-light p-2 rounded shadow-sm">
              <label class="tamaño d-flex align-items-center gap-2 mb-1">
                <i class="bi bi-person-standing text-secondary"></i> TALLA
                PANTALÓN:</label
              >
              <select class="form-select tamaños" v-model="form.posPantalon">
                <option disabled value="">-- SELECCIONAR --</option>
                <option
                  v-for="panta in pantalon"
                  :key="panta.id"
                  :value="panta.parCorrelativo"
                >
                  {{ panta.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="mb-3 bg-light p-2 rounded shadow-sm">
              <label class="tamaño d-flex align-items-center gap-2 mb-1">
                <i class="bi bi-universal-access text-primary"></i> TALLA
                CALZADO:</label
              >
              <select class="form-select tamaños" v-model="form.posZapatos">
                <option disabled value="">-- SELECCIONAR --</option>
                <option
                  v-for="zapato in zapatos"
                  :key="zapato.id"
                  :value="zapato.parCorrelativo"
                >
                  {{ zapato.parDescripcion }}
                </option>
              </select>
            </div>
          </div>

          <!-- COLUMNA DERECHA: RESTO DEL FORMULARIO -->
          <div class="col-12 col-md-9 ps-md-4">
            <div class="row gx-3 gy-2">
              <div class="col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-card-text fs-6 text-primary"></i> TIPO
                  DOCUMENTO:</label
                >

                <b-form-select
                  v-model="form.posTipDocumento"
                  required
                  class="tamaños form-select"
                >
                  <b-form-select-option :value="null"
                    >--SELECCIONAR TIPO DE DOCUMENTO--</b-form-select-option
                  >
                  <b-form-select-option
                    v-for="arreglarItems in arreglar"
                    :key="arreglarItems.id"
                    :value="arreglarItems.parCorrelativo"
                    >{{ arreglarItems.parDescripcion }}</b-form-select-option
                  >
                </b-form-select>
              </div>

              <div class="form-group col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-credit-card fs-6 text-warning"></i> N°
                  DOCUMENTO:</label
                >

                <div>
                  <div
                    v-if="itemExists"
                    class="alert alert-success tamaño text-danger"
                    role="alert"
                  >
                    Dni ya se encuentra registrado en la base de datos
                  </div>
                </div>
                <div class="d-flex">
                  <input
                    required
                    type="number"
                    class="form-control tamaños"
                    v-model="form.posNroDocumento"
                    id="exampleFormControlInput1"
                  />
                  <button
                    class="btn btn-primary py-0 mx-1"
                    @click="consultarDni(form.posNroDocumento)"
                  >
                    <i class="bi bi-search"></i>
                  </button>
                </div>
              </div>

              <!-- <div class="col-lg-1 col-sm-12 py-1">
            <button class="btn btn-primary w-100 mt-4" @click="consultarDni(form.posNroDocumento)"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
</svg></button>


          </div> -->
              <div class="col-sm-12 col-lg-2">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-gender-ambiguous fs-6 text-info"></i>
                  GENERO:</label
                >
                <!-- {{ form.DesTipDocumento }} -->
                <select
                  class="form-select tamaños"
                  @change="Generosi($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>
                    {{ form.posGenero || "--SELECCIONAR GENERO--" }}
                  </option>
                  <option
                    :value="generoItems.parCorrelativo"
                    v-for="generoItems in genero"
                    :key="generoItems.id"
                  >
                    {{ generoItems.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="col-lg-4 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-people fs-6 text-success"></i> ESTADO
                  CIVIL:</label
                >
                <select
                  class="form-select tamaños"
                  @change="EstadoCivil($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>
                    {{ form.posEstCivil || "-- SELECCIONAR ESTADO CIVIL--" }}
                  </option>
                  <option
                    :value="estadoCivil.parCorrelativo"
                    v-for="estadoCivil in estadoCivil"
                    :key="estadoCivil.id"
                  >
                    {{ estadoCivil.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="form-group col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-person fs-6 text-success"></i> APELLIDO
                  PATERNO:</label
                >
                <input
                  type="text"
                  class="form-control tamaños"
                  v-model="form.posApePaterno"
                  id="exampleFormControlInput1"
                  required
                  @input="
                    form.posApePaterno = form.posApePaterno.replace(/^\s+/, '')
                  "
                />
              </div>

              <div class="form-group col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-person fs-6 text-info"></i> APELLIDO
                  MATERNO:</label
                >

                <input
                  type="text"
                  class="form-control tamaños"
                  v-model="form.posApeMaterno"
                  id="exampleFormControlInput1"
                  required
                  @input="
                    form.posApeMaterno = form.posApeMaterno.replace(/^\s+/, '')
                  "
                />
              </div>

              <div class="form-group col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-person-badge fs-6 text-primary"></i>
                  NOMBRES:</label
                >

                <input
                  type="text"
                  class="form-control tamaños"
                  v-model="form.posNombre"
                  id="exampleFormControlInput1"
                  required
                  @input="form.posNombre = form.posNombre.replace(/^\s+/, '')"
                />
              </div>

              <div class="form-group col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-calendar fs-6 text-warning"></i> FECH.
                  NACIMIENTO:</label
                >
                <input
                  type="date"
                  class="form-control tamaños"
                  v-model="form.posFecNacimiento"
                  id="exampleFormControlInput1"
                  required
                />
              </div>

              <div class="col-lg-3 col-sm-12 position-relative">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-flag fs-6 text-primary"></i> PAIS:</label
                >

                <input
                  type="text"
                  class="form-control tamaños"
                  placeholder="Escribir para buscar país..."
                  v-model="filtroPais"
                  @input="filtroPais = filtroPais.replace(/^\s+/, '')"
                  @focus="mostrarListaPais = true"
                  @blur="ocultarListaPais"
                />

                <!-- Lista filtrada -->
                <ul
                  v-if="mostrarListaPais && paisesFiltrados.length"
                  class="list-group position-absolute w-100 mt-1 shadow-sm"
                  style="z-index: 2000; max-height: 180px; overflow-y: auto"
                >
                  <li
                    v-for="pais in paisesFiltrados"
                    :key="pais.id"
                    class="list-group-item list-group-item-action tamaños"
                    @mousedown.prevent="seleccionarPais(pais)"
                  >
                    {{ pais.parDescripcion }}
                  </li>
                </ul>
              </div>

              <!-- pais copia -->
              <!-- <div class="col-lg-3 col-sm-12">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi-flag fs-6 text-primary"></i> PAIS:</label>
              <select class="form-select tamaños"  @change="Pais($event)" aria-label="Default select example">
                <option selected disabled>{{ form.posPais || "--SELECCIONAR PAIS--" }}</option>
                <option :value="paisEstados.parCorrelativo" v-for="paisEstados in paisEstado" :key="paisEstados.id">
                  {{ paisEstados.parDescripcion }}
                </option>
              </select>
            </div> -->

              <div class="col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-flag-fill fs-6 text-info"></i>
                  NACIONALIDAD:</label
                >
                <select
                  class="form-select tamaños"
                  @change="Nacion($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>-- SELECCIONAR NACIONALIDAD</option>
                  <option
                    :value="nacionEstados.parCorrelativo"
                    v-for="nacionEstados in nacionEstado"
                    :key="nacionEstados.id"
                  >
                    {{ nacionEstados.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="col-lg-2 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-building fs-6 text-warning"></i>
                  DEPARTAMENTO:</label
                >
                <select
                  class="form-select tamaños"
                  @change="DepartamentoEvent($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>
                    --SELECCIONAR DEPARTAMENTO--
                  </option>
                  <option
                    :value="departamentoDistritos.idParametro"
                    v-for="departamentoDistritos in departamentoDistrito"
                    :key="departamentoDistritos.id"
                  >
                    {{ departamentoDistritos.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="col-lg-2 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-building fs-6 text-success"></i>
                  PROVINCIA:</label
                >
                <select
                  class="form-select tamaños"
                  @change="ProvinciaEvent($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>--SELECCIONAR PROVINCIA--</option>
                  <option
                    :value="provinciaDepas.idParametro"
                    v-for="provinciaDepas in provinciaDepa"
                    :key="provinciaDepas.id"
                  >
                    {{ provinciaDepas.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="col-lg-2 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-geo-alt fs-6 text-primary"></i> DISTRITO:</label
                >
                <select
                  class="form-select tamaños"
                  @change="DistritoEvent($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>--SELECCIONAR DISTRITO--</option>
                  <option
                    :value="distritoProvins.parCorrelativo"
                    v-for="distritoProvins in distritoProvin"
                    :key="distritoProvins.id"
                  >
                    {{ distritoProvins.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="form-group col-lg-2 col-sm-12">
                <label class="tamaño">
                  <i class="bi-people fs-6 text-secondary"></i> CANT.
                  HIJ.:</label
                >
                <input
                  type="number"
                  class="form-control tamaños"
                  min="0"
                  oninput="if(this.value < 0) this.value = 0;"
                  v-model="form.posCanHijos"
                  id="exampleFormControlInput1"
                />
              </div>

              <div class="form-group col-lg-2 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-people fs-6 text-secondary"></i> HIJO.
                  MEN:</label
                >
                <input
                  type="number"
                  class="form-control tamaños"
                  min="0"
                  oninput="if(this.value < 0) this.value = 0;"
                  v-model="form.posHijosMen"
                  id="exampleFormControlInput1"
                />
              </div>

              <div class="form-group col-lg-4 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-person-check fs-6 text-warning"></i> ESTADO DEL
                  POSTULANTE:</label
                >
                <input
                  type="text"
                  class="form-control tamaños"
                  :disabled="isdisabled"
                  v-model="posEstadoConvoca"
                  id="exampleFormControlInput1"
                />
              </div>

              <div class="form-group col-lg-2 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-telephone fs-6 text-success"></i> TELEFONO</label
                >
                <input
                  type="number"
                  class="form-control tamaños"
                  v-model="form.posTelefono"
                  id="exampleFormControlInput1"
                  required
                  @input="
                    form.posTelefono = form.posTelefono
                      .toString()
                      .replace(/^\s+/, '')
                  "
                />
              </div>

              <div class="form-group col-lg-2 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-telephone fs-6 text-primary"></i> TELEFONO
                  ADICIONAL</label
                >
                <input
                  type="number"
                  class="form-control tamaños"
                  v-model="form.posTelAdicional"
                  id="exampleFormControlInput1"
                  @input="
                    form.posTelAdicional = form.posTelAdicional
                      ?.toString()
                      .replace(/^\s+/, '')
                  "
                />
              </div>

              <div class="form-group col-lg-4 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-envelope fs-6 text-info"></i> CORREO:</label
                >
                <input
                  type="email"
                  class="form-control tamaños"
                  v-model="form.posCorreo"
                  required
                  id="exampleFormControlInput1"
                  @input="form.posCorreo = form.posCorreo.replace(/^\s+/, '')"
                />
              </div>

              <div class="form-group col-lg-5 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-geo-alt fs-6 text-danger"></i> DIRECCION:</label
                >
                <input
                  type="text"
                  class="form-control tamaños"
                  v-model="form.posDireccion"
                  id="exampleFormControlInput1"
                  @input="
                    form.posDireccion = form.posDireccion.replace(/^\s+/, '')
                  "
                />
              </div>

              <!-- <div class="form-group col-lg-3 col-sm-12 ">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi-briefcase fs-6 text-warning"></i> PERFIL PROFESIONAL:</label>

              <input type="text" class="form-control tamaños" v-model="form.posPerProfesional"
                id="exampleFormControlInput1"
                @input="form.posPerProfesional = form.posPerProfesional.replace(/^\s+/, '')" />

            </div> -->

              <!-- <div class="form-group col-lg-5 col-sm-12 ">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi-briefcase-fill fs-6 text-success"></i> OCUPACION:</label>
              <input type="text" class="form-control tamaños" v-model="form.posOcupacion" id="exampleFormControlInput1"
                @input="form.posOcupacion = form.posOcupacion.replace(/^\s+/, '')" />

            </div> -->

              <div class="col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-mortarboard fs-6 text-dark"></i> GRADO
                  ACADEMICO:</label
                >
                <select
                  class="form-select tamaños"
                  @change="GradoAcademico($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>
                    --SELECCIONAR GRADO ACADEMICO--
                  </option>
                  <option
                    :value="gradoAcademicos.parCorrelativo"
                    v-for="gradoAcademicos in gradoAcademico"
                    :key="gradoAcademicos.id"
                  >
                    {{ gradoAcademicos.parDescripcion }}
                  </option>
                </select>
              </div>

              <!-- <div class="form-group col-lg-4 col-sm-12 ">
              <label class="tamaño d-flex align-items-center gap-2">
                <i class="bi-journal-bookmark fs-6 text-dark"></i> ESTUDIOS SUPERIORES:</label>
              <input type="text" class="form-control tamaños" v-model="form.posEstudios" id="exampleFormControlInput1"
                @input="form.posEstudios = form.posEstudios.replace(/^\s+/, '')" />

            </div> -->

              <div class="form-group col-lg-6 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-file-earmark fs-6 text-primary"></i>
                  ADJUNTO:</label
                >
                <input
                  type="file"
                  class="form-control tamaños"
                  @change="onFileSelected"
                  id="exampleFormControlInput1"
                />

                <!-- v-model="form.posAdjunto" -->
              </div>

              <div class="form-group col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-person-plus fs-6 text-info"></i> USUARIO
                  CREADO:</label
                >
                <input
                  type="text"
                  class="form-control tamaños"
                  :disabled="isdisabled"
                  v-model="posUsuCreado"
                  id="exampleFormControlInput1"
                />
              </div>

              <div class="col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-toggle-on fs-6 text-primary"></i> ESTADO:</label
                >
                <select
                  class="form-select tamaños"
                  @change="Estado($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>--SELECCIONAR ESTADO--</option>
                  <option
                    :value="EstadoStatuse.parCorrelativo"
                    v-for="EstadoStatuse in EstadoStatus"
                    :key="EstadoStatuse.id"
                  >
                    {{ EstadoStatuse.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="col col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2"
                  ><i class="bi-slash-circle fs-6 text-danger"></i> MOTIVO DE
                  BLOQUEO:</label
                >
                <select
                  disabled
                  class="form-select tamaños"
                  @change="Estado($event)"
                  aria-label="Default select example"
                >
                  <option selected disabled>--SELECCIONAR ESTADO--</option>
                  <option
                    :value="EstadoStatuse.parCorrelativo"
                    v-for="EstadoStatuse in EstadoStatus"
                    :key="EstadoStatuse.id"
                  >
                    {{ EstadoStatuse.parDescripcion }}
                  </option>
                </select>
              </div>

              <div class="col col-lg-3 col-sm-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi-cash fs-6 text-success"></i>
                  ¿TIENES RENTA QUINTA?</label
                >
                <div class="form-group d-flex align-items-center">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.posRentaQuinta"
                    />
                  </div>
                </div>
              </div>

              <div></div>
            </div>
          </div>
          <!-- bancos -->

          <div class="mt-5 row gx-2 gy-2">
            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-cash fs-6 text-info me-2"></i> BANCO
                HABERES:</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posHaberesTipo = $event.target.value"
                >
                  <option disabled selected>--Seleccionar banco hab.--</option>
                  <option
                    v-for="banco in bancoHaber"
                    :key="banco.id"
                    :value="banco.parCorrelativo"
                  >
                    {{ banco.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-coin fs-6 text-success me-2"></i> MONEDA
                (HAB.):</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posTipoMoneda = $event.target.value"
                >
                  <option disabled selected>--Seleccionar moneda hab.--</option>
                  <option
                    v-for="mone in moneda"
                    :key="mone.id"
                    :value="mone.parCorrelativo"
                  >
                    {{ mone.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-cash-stack fs-6 text-danger me-2"></i> BANCO DE
                CTS:</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posCtsTipo = $event.target.value"
                >
                  <option disabled selected>--Seleccionar banco cts--</option>
                  <option
                    v-for="banco in banCts"
                    :key="banco.id"
                    :value="banco.parCorrelativo"
                  >
                    {{ banco.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="tamaño">Moneda(CTS):</label>

              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posTipoMonedaCts = $event.target.value"
                >
                  <option disabled selected>Seleccionar moneda cts</option>
                  <option
                    v-for="mone in moneda"
                    :key="mone.id"
                    :value="mone.parCorrelativo"
                  >
                    {{ mone.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-coin text-warning fs-6 me-2"></i>
                Sistema Pensiones:</label
              >
              <div>
                <select
                  class="form-select tamaños"
                  aria-label="Default select example"
                  @change="form.posSistemaPensiones = $event.target.value"
                >
                  <option disabled selected>
                    --Seleccionar sistema de pensiones--
                  </option>
                  <option
                    v-for="pensiones in sistemPension"
                    :key="pensiones.id"
                    :value="pensiones.parCorrelativo"
                  >
                    {{ pensiones.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-telephone fs-6 text-info me-2"></i>
                CONTAC. DE EMERG. (NOMBRES):</label
              >
              <input
                type="text"
                class="form-control tamaños"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                v-model="form.posEmeContacto"
              />
            </div>

            <div class="col col-lg-3 col-sm-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-phone fs-6 text-primary me-2"></i> N° DE
                CELULAR:</label
              >
              <input
                type="text"
                class="form-control tamaños"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                v-model="form.posEmeTelefono"
              />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <button
            :disabled="isdisabled2 || itemExists"
            type="submit"
            class="btn btn-success mx-2 px-3 py-2 textoGrande"
          >
            <i class="bi bi-floppy"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  name: "SolimanologNuevoPostulante",

  data() {
    return {
      datos: null,
      alerta: false,
      duplicado: false,
      posUsuCreado: "",
      posCorreoEnviado: "",
      posEstadoConvoca: "",
      isdisabled: true,
      isdisabledInput: true,
      form: {
        // idPostulante: "",
        idUsuario: "",
        posTipDocumento: null,
        posNroDocumento: "",
        posNombre: "",
        posApePaterno: "",
        posApeMaterno: "",
        posFecNacimiento: "",
        posGenero: "",
        posEstCivil: "",
        posTelefono: "",
        posTelAdicional: "",
        posPais: "",
        posUbigeo: "",
        posNacionalidad: "",
        posPerProfesional: "",
        posAdjunto: "1",
        posEstado: "",
        posOcupacion: "",
        posCorreo: "",

        posCanHijos: "0",
        posDireccion: "",
        posHijosMen: "0",
        posGradoAcademico: "",
        posEstudios: "",
        posRentaQuinta: false,
        posPolo: "",
        posPantalon: "",
        posZapatos: "",
        PosImagen: 1,
        posHaberesTipo: "",
        posTipoMoneda: "",
        posCtsTipo: "",
        posTipoMonedaCts: "",
        posSistemaPensiones: 0,
        posEmeContacto: "",
        posEmeTelefono: "",
      },
      polos: [],
      pantalon: [],
      zapatos: [],
      previewUrl: null,
      loadingImagen: false,
      gradoAcademico: [],
      arreglar: [],
      genero: [],
      estadoCivil: [],
      paisEstado: [],
      nacionEstado: [],
      EstadoStatus: [],
      departamentoDistrito: [],
      provinciaDepa: [],
      distritoProvin: [],
      validarDni: [],
      selectedFile: "1",
      filtroPais: "",
      mostrarListaPais: false,
      isdisabled2: false,
      itemExists: false, // Variable para rastrear si el DNI ya se ha encontrado

      sistemPension: [],
      moneda: [],
      banCts: [],
      bancoHaber: [],
    };
  },

  watch: {
    "form.posNroDocumento": function (newVal) {
      // Cada vez que el valor de form.posNroDocumento cambia, verifica si existe en la lista
      this.itemExists = this.Info.some(
        (item) => item.posNroDocumento === newVal
      );
    },
  },
  async mounted() {
    // const response = await this.axios.get(
    //   "Postulante/ListaPostulante"
    // );
    // this.validarDni = response.data
    // console.log(this.validarDni)

    this.form.idUsuario = localStorage.getItem("userId");
    console.log(this.form.idUsuario);

    this.axios.get("ParametroData/Parametro/2535").then((r) => {
      this.sistemPension = r.data;
    });

    this.axios.get("ParametroData/Parametro/7320").then((r) => {
      this.bancoHaber = r.data;
    });

    this.axios.get("ParametroData/Parametro/7317").then((r) => {
      this.moneda = r.data;
    });

    this.axios.get("ParametroData/Parametro/7361").then((r) => {
      this.banCts = r.data;
    });

    this.axios.get("ParametroData/Parametro/1").then((datos) => {
      // console.log(datos.data);
      this.arreglar = datos.data;
    });

    this.axios.get("ParametroData/Parametro/64").then((datos) => {
      // console.log(datos.data);
      this.genero = datos.data;
    });
    this.axios.get("ParametroData/Parametro/69").then((datos) => {
      // console.log(datos.data);
      this.estadoCivil = datos.data;
    });

    this.axios.get("ParametroData/Parametro/75").then((datos) => {
      // console.log(datos.data);
      this.paisEstado = datos.data;
    });

    this.axios.get("ParametroData/Parametro/2405").then((datos) => {
      // console.log(datos.data);
      this.nacionEstado = datos.data;
    });

    this.axios.get("ParametroData/Parametro/2421").then((datos) => {
      // console.log(datos.data);
      this.EstadoStatus = datos.data;
    });

    this.axios.get("ParametroData/Parametro/350").then((datos) => {
      this.departamentoDistrito = datos.data;
    });

    this.axios.get("ParametroData/Parametro/8006").then((r) => {
      this.polos = r.data;
    });

    this.axios.get("ParametroData/Parametro/8013").then((r) => {
      this.pantalon = r.data;
    });

    this.axios.get("ParametroData/Parametro/8024").then((r) => {
      this.zapatos = r.data;
    });

    this.axios.get("ParametroData/Parametro/2475").then((r) => {
      console.log(r.data);
      this.gradoAcademico = r.data;
    });
  },

  computed: {
    ...mapGetters("listadoPostulante", ["Info"]),

    paisesFiltrados() {
      if (!this.filtroPais) return this.paisEstado;
      const busqueda = this.filtroPais.toLowerCase();
      return this.paisEstado.filter((p) =>
        p.parDescripcion.toLowerCase().includes(busqueda)
      );
    },
  },

  methods: {
    ...mapActions("listadoPostulante", ["getAttributesPostulante"]),
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);
    },

    //   trimInput() {
    //   this.form.posNombre = this.form.posNombre.trim();
    //   this.form.posApePaterno = this.form.posApePaterno.trim();
    // },

    consultarDni(dni) {
      this.axios.get(`Webscraping/BuscarDatosxDni?DNI=${dni}`).then((r) => {
        console.log(r);
        if (r.status == 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se válido datos con RENIEC!",
            showConfirmButton: true,
            timer: 1500,
          });
        }

        this.form.posNombre = r.data.nombres;
        this.form.posApePaterno = r.data.apellidoPaterno;
        this.form.posApeMaterno = r.data.apellidoMaterno;
      });
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.PosImagen = file;

        // Crear previsualización local
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.previewUrl = null;
      }
    },

    seleccionarPais(pais) {
      this.filtroPais = pais.parDescripcion;
      this.form.posPais = pais.parCorrelativo;
      this.mostrarListaPais = false;
      console.log("País seleccionado:", this.form.posPais);
    },
    ocultarListaPais() {
      setTimeout(() => (this.mostrarListaPais = false), 200);
    },

    registrar() {
      this.isdisabled2 = true;
      const fd = new FormData();
      console.log(fd);
      fd.append("idUsuario", this.form.idUsuario);
      fd.append("PosTipDocumento", this.form.posTipDocumento);
      fd.append("PosNroDocumento", this.form.posNroDocumento);
      fd.append("PosGenero", this.form.posGenero);
      fd.append("PosEstCivil", this.form.posEstCivil);
      fd.append("PosPais", this.form.posPais);
      fd.append("PosNacionalidad", this.form.posNacionalidad);
      fd.append("PosEstado", this.form.posEstado);
      fd.append("PosUbigeo", this.form.posUbigeo);
      fd.append("PosNombre", this.form.posNombre);
      fd.append("PosApePaterno", this.form.posApePaterno);
      fd.append("PosApeMaterno", this.form.posApeMaterno);
      fd.append("PosFecNacimiento", this.form.posFecNacimiento);
      fd.append("PosTelefono", this.form.posTelefono);
      fd.append("PosTelAdicional", this.form.posTelAdicional);
      fd.append("PosPerProfesional", this.form.posPerProfesional);
      fd.append("ArchivoPos", this.selectedFile);
      fd.append("PosAdjunto", this.selectedFile);

      fd.append("PosOcupacion", this.form.posOcupacion);
      fd.append("PosCorreo", this.form.posCorreo);
      fd.append("PosCanHijos", this.form.posCanHijos);
      fd.append("PosDireccion", this.form.posDireccion);
      fd.append("PosHijosMen", this.form.posHijosMen);
      fd.append("PosGradoAcademico", this.form.posGradoAcademico);
      fd.append("PosEstudios", this.form.posEstudios);
      fd.append("posRentaQuinta", this.form.posRentaQuinta);
      
      fd.append("posHaberesTipo", this.form.posHaberesTipo);
      fd.append("posTipoMoneda", this.form.posTipoMoneda);
      fd.append("posCtsTipo", this.form.posCtsTipo);
      fd.append("posTipoMonedaCts", this.form.posTipoMonedaCts);
      fd.append("posSistemaPensiones", this.form.posSistemaPensiones);
      fd.append("posEmeContacto", this.form.posEmeContacto);
      fd.append("posEmeTelefono", this.form.posEmeTelefono);

      fd.append("posPolo", this.form.posPolo);
      fd.append("posPantalon", this.form.posPantalon);
      fd.append("posCalzado", this.form.posZapatos);    

        fd.append("PosImagen", this.form.PosImagen);
        fd.append("ImagenGuardada", this.form.PosImagen);


      this.axios.post(`Postulante/Registrare`, fd).then((data) => {
        console.log(data.data);

        if (data.data == true) {
          this.isdisabled2 = false;
          window.scroll(0, 0);

          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se registró con Éxito!!",
            showConfirmButton: false,
            timer: 3000,
          });
          this.getAttributesPostulante();
          this.resetFormulario();
        } else {
          window.scroll(0, 0);
          this.duplicado = true;
          setTimeout(() => {
            this.duplicado = false;
          }, 3000);
          this.alerta = false;
        }
      });
    },
    resetFormulario() {
      this.form = {
        idUsuario: this.form.idUsuario, // se mantiene
        posTipDocumento: null,
        posNroDocumento: "",
        posNombre: "",
        posApePaterno: "",
        posApeMaterno: "",
        posFecNacimiento: "",
        posGenero: "",
        posEstCivil: "",
        posTelefono: "",
        posTelAdicional: "",
        posPais: "",
        posUbigeo: "",
        posNacionalidad: "",
        posPerProfesional: "",
        posAdjunto: "1",
        posEstado: "",
        posOcupacion: "",
        posCorreo: "",
        posCanHijos: "0",
        posDireccion: "",
        posHijosMen: "0",
        posGradoAcademico: "",
        posEstudios: "",
        posRentaQuinta: false,
        posPolo: "",
        posPantalon: "",
        posZapatos: "",
        PosImagen: null,
      };

      this.selectedFile = null;
      this.itemExists = false;
      this.isdisabled2 = false;
      this.previewUrl = null;
      this.duplicado = false;
      this.alerta = false;
      this.provinciaDepa = [];
      this.distritoProvin = [];
      this.filtroPais = "";
    },

    GradoAcademico(event) {
      this.form.posGradoAcademico = event.target.value;
    },

    Generosi(event) {
      this.form.posGenero = event.target.value;
      console.log(this.form.posGenero);
    },

    EstadoCivil(event) {
      this.form.posEstCivil = event.target.value;
      console.log(this.form.posEstCivil);
    },

    Pais(event) {
      this.form.posPais = event.target.value;
      console.log(this.form.posPais);
    },
    Nacion(event) {
      this.form.posNacionalidad = event.target.value;
      console.log(this.form.posNacionalidad);
    },

    Estado(event) {
      this.form.posEstado = event.target.value;
      console.log(this.form.posEstado);
    },

    DepartamentoEvent(event) {
      console.log(event.target.value);

      this.axios
        .get(`ParametroData/Parametro/${event.target.value}`)
        .then((datos) => {
          this.provinciaDepa = datos.data;
        });
    },
    ProvinciaEvent(event) {
      console.log(event.target.value);

      let province = event.target.value;

      this.axios.get(`DistritoData/Listar/${province}`).then((datos) => {
        this.distritoProvin = datos.data;
      });
    },

    DistritoEvent(event) {
      this.form.posUbigeo = event.target.value;
      console.log(this.form.posUbigeo);
    },
  },
};
</script>

<style scoped>
.tamaño {
  font-size: 0.65rem;
  font-weight: 800;
  color: #002c5d;
  margin-bottom: 3px;
}

.tamaños {
  font-size: 0.65rem;
  border-radius: 6px;
}

.reducirTamaño {
  font-size: 0.6rem;
  line-height: 1.2;
}

.textoGrande {
  font-size: 1.2rem;
}

.image-upload-circle {
  width: 160px;
  height: 160px;
  border: 3px solid #e9ecef;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.3s ease;
}

.image-upload-circle:hover {
  border-color: #198754;
}

.img-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay-camera {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 35px;
  background: rgba(0, 44, 93, 0.6);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-upload-circle:hover .overlay-camera {
  opacity: 1;
}
</style>
